import axiosInstance from "@/setup/axios/axiosInstance";

let orderStatusesCache: any[] | null = null;

let orderStatusesInFlight: Promise<any[]> | null = null;

const normalizeOrderStatusesFromSettings = (data: any): any[] => {
  const modulePayload = data?.orders || data;

  if (Array.isArray(modulePayload?.groups) && modulePayload.groups.length > 0) {
    return modulePayload.groups.flatMap((group: any) => {
      const groupStatus = group?.group_status || null;
      const items = Array.isArray(group?.items) ? group.items : [];
      return items.map((item: any) => ({
        ...item,
        group_status: item?.group_status || groupStatus,
      }));
    });
  }

  if (Array.isArray(modulePayload?.items)) {
    return modulePayload.items;
  }

  return Array.isArray(modulePayload) ? modulePayload : [];
};

export const clearOrderStatusesCache = () => {
  orderStatusesCache = null;
};

// Function to fetch order statuses from backend
export const fetchOrderStatuses = async (options?: { force?: boolean }) => {
  const force = options?.force === true;

  if (!force && orderStatusesInFlight) {
    return orderStatusesInFlight;
  }

  orderStatusesInFlight = (async () => {
  try {
    const response = await axiosInstance.get("/settings/statuses/by-module/?module=orders");
    const normalized = normalizeOrderStatusesFromSettings(response.data);
    orderStatusesCache = normalized;
    return normalized;
  } catch (error) {
    console.error("Error fetching order statuses:", error);
    return orderStatusesCache || [];
  } finally {
    orderStatusesInFlight = null;
  }
  })();

  return orderStatusesInFlight;
};

// Function to fetch additional fees from backend
export const fetchAdditionalFees = async () => {
  try {
    const response = await axiosInstance.get("/orders/additional-fees/");
    return response.data.results || response.data || [];
  } catch (error) {
    console.error("Error fetching additional fees:", error);
    return [];
  }
};

// Function to fetch shipping fees from backend
export const fetchShippingFees = async () => {
  try {
    const response = await axiosInstance.get("/orders/shipping-installation-fees/");
    return response.data.results || response.data || [];
  } catch (error) {
    console.error("Error fetching shipping fees:", error);
    return [];
  }
};

// Function to fetch units from backend
export const fetchUnits = async () => {
  try {
    const response = await axiosInstance.get("/inventory/units/");
    const rawUnits = response.data.results || response.data || [];
    const normalizedUnits = (Array.isArray(rawUnits) ? rawUnits : []).map((unit: any) => ({
      id: String(unit?.id || unit?.unit_id || unit?.uom_id || ''),
      name: unit?.name || unit?.title || unit?.code || '',
      code: unit?.code || unit?.name || unit?.title || '',
    }));

    return normalizedUnits.filter((unit: any) => unit.id);
  } catch (error) {
    console.error("Error fetching units:", error);
    return [];
  }
};

// Function to fetch sales channels from backend
export const fetchSalesChannels = async () => {
  try {
    const response = await axiosInstance.get("/orders/sales-channels/");
    return response.data.results || response.data || [];
  } catch (error) {
    console.error("Error fetching sales channels:", error);
    return [];
  }
};

// Function to fetch companies from backend
export const fetchCompanies = async () => {
  try {
    const response = await axiosInstance.get("/companies/");
    return response.data.results || response.data || [];
  } catch (error) {
    console.error("Error fetching companies:", error);
    return [];
  }
};

